var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgK29(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9326 10.3047C23.6178 9.88919 24.4821 9.89938 25.1592 10.3311C26.1503 10.9653 27.4672 12.0331 27.8945 13.4189C28.6084 15.7369 29.6784 18.5903 27.0039 21.7998C27.0039 21.7998 28.4293 27.8629 25.042 30.7158C25.0326 30.7201 22.5686 31.8259 22.9014 29.6465C23.1196 28.2284 23.1037 22.9737 19.8604 22.7168C16.6176 22.9729 16.6014 28.2271 16.8184 29.6465C17.1516 31.8244 14.6907 30.7216 14.6777 30.7158C11.291 27.8636 12.7168 21.7998 12.7168 21.7998C10.0428 18.5895 11.1123 15.7369 11.8262 13.4189C12.2528 12.0332 13.57 10.9653 14.5625 10.3311C15.2385 9.8993 16.1035 9.88882 16.79 10.3047L18.5596 11.377C19.3597 11.8619 20.3623 11.8619 21.1631 11.377L22.9326 10.3047ZM22.5693 12.8564C22.1195 12.8566 21.7552 13.2211 21.7549 13.6709C21.7549 14.121 22.1193 14.4861 22.5693 14.4863C22.9893 14.4864 23.6469 14.6497 24.165 15.1357C24.6535 15.594 25.1127 16.4282 25.0166 17.9678C24.9885 18.417 25.3301 18.8038 25.7793 18.832C26.2286 18.86 26.6155 18.5186 26.6436 18.0693C26.7645 16.1316 26.1828 14.7922 25.2812 13.9463C24.4092 13.1282 23.3269 12.8565 22.5693 12.8564Z",
    fill: "url(#paint0_radial_5230_24377)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5230_24377",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.3001 37.1324) rotate(-90) scale(32.3168 81.4012)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgK29);
export default __webpack_public_path__ + "static/media/K29.e6fad345f83f0367f0e68569f4fb8bee.svg";
export { ForwardRef as ReactComponent };